import { render } from "./UserVerification.vue?vue&type=template&id=3972d032&scoped=true"
import script from "./UserVerification.vue?vue&type=script&lang=js"
export * from "./UserVerification.vue?vue&type=script&lang=js"

import "./UserVerification.vue?vue&type=style&index=0&id=3972d032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3972d032"]])

export default __exports__